"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPdfText = void 0;
const pdf_1 = require("pdfjs-dist/legacy/build/pdf");
const array_1 = require("./array");
const getPdfText = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const invoice = yield pdf_1.getDocument({ data }).promise;
    const textLinesByPage = yield Promise.all(array_1.arrayOf(invoice.numPages).map((_page, i) => __awaiter(void 0, void 0, void 0, function* () {
        const page = yield invoice.getPage(i + 1);
        const textContent = yield page.getTextContent();
        return textContent.items
            .slice(0, -1)
            .map((text) => text.str);
    })));
    return textLinesByPage.reduce((text, textOnPage) => [
        ...text,
        ...textOnPage,
    ], []);
});
exports.getPdfText = getPdfText;
//# sourceMappingURL=pdf.js.map